/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {StorageUtils, EEmbededElementTypes, RenderDocument} from "js_renderer";
import Element from "./element";
import Factory from "./factory";

export default
class SkyBox  extends Element {

    public static TypeName: string = EEmbededElementTypes.SKYBOX;
    private _url: string;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        this._url = '@assets/images/skybox.png';
    }

    public static create(aRenderDocument: RenderDocument): SkyBox {
        let element = new SkyBox(aRenderDocument);
        element._typeName = SkyBox.TypeName;
        return element;
    }

    public setTextureUrl(aUrl: string) {
        this._url = aUrl;
    }

    public getFogColor(): number[] {
        return [0.843, 0.8, 0.69];
    }

    protected _generateElementDescriptionJSON(): any {
        return {
            "type": this.getTypeName(),
            "id": this.getTypeName() + "_" + this._UID,   // this is is not important in the engine, it can identify e.g. id of an element in Lexocad
            "UID": this._UID
        };
    }

    protected _generateGeometryObjectDescriptionJSON(): any {
        let appearanceContent: any = {};

        appearanceContent.imageTexture = {
            url: [this._url],
            width: [0],
            height: [0],
            offsets: [0],
            sizes: [0],
            tiled: [false],
            alpha: false,
            model: "REPLACE",
            blendColor: [0.00392157, 0.00392157, 0.00392157],
            repeatS: 0,
            repeatT: 0
        };

        return [{
            description: {
                type: "SKYBOX",
                bboxMin: [0.0, 0.0, 0.0],
                bboxMax: [100.0, 100.0, 100.0]
            },
            appearance: appearanceContent,
            indexedFaceSet: {
                src: this._renderDocument.getRenderer()._dataStorage.createLocalResourceUri(),
                vertexCount: 36,
                normalCount: 0,
                texcoordCount: 36,
                indexCount: 36,
                binSize: 0,
                positions: [
                    0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 1.0, 0.0, 1.0, // front
                    1.0, 0.0, 1.0, 0.0, 1.0, 1.0, 1.0, 1.0, 1.0,
                    0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 1.0, 0.0, // back
                    1.0, 0.0, 0.0, 1.0, 1.0, 0.0, 0.0, 1.0, 0.0,
                    1.0, 0.0, 1.0, 1.0, 1.0, 1.0, 1.0, 0.0, 0.0, // right
                    1.0, 0.0, 0.0, 1.0, 1.0, 1.0, 1.0, 1.0, 0.0,
                    0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 1.0, // left
                    0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 1.0,
                    0.0, 1.0, 1.0, 0.0, 1.0, 0.0, 1.0, 1.0, 1.0, // top
                    0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0, 1.0,
                    0.0, 0.0, 1.0, 1.0, 0.0, 1.0, 0.0, 0.0, 0.0, // bottom
                    0.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 0.0
                ],
                normals: [],
                texCoords: [
                    0.25, 0.50, 0.25, 0.25, 0.50, 0.50, // front
                    0.50, 0.50, 0.25, 0.25, 0.50, 0.25,
                    0.999, 0.50, 0.75, 0.50, 0.999, 0.25, // back
                    0.75, 0.50, 0.75, 0.25, 0.999, 0.25,
                    0.50, 0.50, 0.50, 0.25, 0.75, 0.50, // right
                    0.75, 0.50, 0.50, 0.25, 0.75, 0.25,
                    0.25, 0.50, 0.005, 0.50, 0.25, 0.25, // left
                    0.00, 0.50, 0.005, 0.25, 0.25, 0.25,
                    0.25, 0.25, 0.25, 0.001, 0.50, 0.25, // top
                    0.25, 0.001, 0.50, 0.001, 0.50, 0.25,
                    0.25, 0.75, 0.50, 0.75, 0.25, 0.50, // bottom
                    0.25, 0.50, 0.50, 0.75, 0.50, 0.50
                ],
                indices: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35]
            }
        }];
    }
}

Factory.register(SkyBox);
